import { clsx } from 'clsx';

function Skeleton({ className, ...props }) {
  return (
    <div
      className={clsx(
        'animate-pulse rounded-md bg-neutral-200 dark:bg-neutral-800',
        className,
      )}
      aria-hidden="true"
      {...props}
    />
  );
}

function SkeletonText({ lines = 3, className }) {
  return (
    <div className={clsx('flex flex-col gap-2', className)} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={clsx('h-4', i === lines - 1 ? 'w-3/5' : 'w-full')}
        />
      ))}
    </div>
  );
}

function SkeletonCard({ className }) {
  return (
    <div className={clsx('bg-surface border border-border rounded-lg p-5 flex flex-col gap-4', className)} aria-hidden="true">
      <Skeleton className="h-5 w-2/5" />
      <SkeletonText lines={3} />
      <Skeleton className="h-9 w-28 rounded-md" />
    </div>
  );
}

Skeleton.Text = SkeletonText;
Skeleton.Card = SkeletonCard;

export default Skeleton;
